module.exports = __webpack_public_path__ + "static/scarab_of_protection-613813be7ddbdd463596ba5c665e3c83.jpeg";